import React from "react";

export default ({ data }) => {
  return (
    <div className="flex flex-col justify-between mx-auto">
        <div className="border-b border-gray-200">
          <a href={data.navprodtop[0].url} className="text-base font-bold">
            {data.navprodtop[0].displaytext}
          </a>
          <p className="text-sm mb-6">{data.navprodtop[0].description}</p>
        </div>

        <div className="grid grid-cols-1 gap-0 lg:gap-6 lg:grid-cols-3 py-4">
          <div>
            {data.navprodcol1.map((item) => (
              <a key={item.url} href={item.url}>
                <div>
                  <h5 className="text-base font-bold mb-1">
                    {item.displaytext}
                  </h5>
                  <p className="text-sm mb-6">{item.description}</p>
                </div>
              </a>
            ))}
          </div>

          <div>
            {data.navprodcol2.map((item) => (
              <a key={item.url} href={item.url}>
                <div>
                  <h5 className="text-base font-bold mb-1">
                    {item.displaytext}
                  </h5>
                  <p className="text-sm mb-6">{item.description}</p>
                </div>
              </a>
            ))}
          </div>
          <div></div>
        </div>
      <div></div>
    </div>
  );
};
